import React, { useState, useEffect } from 'react';
import '../Styles/EmbeddedPDF.css';


const EmbeddedPDF = ({link}) => {
    const [embedHeight, setEmbedHeight] = useState(0);
    const [embedWidth, setEmbedWidth] = useState(0);


    const checkWindowSize = () => {
        const windowWidth = window.innerWidth;


        if (windowWidth > 1000) {
            setEmbedHeight(700);
            setEmbedWidth(700);
        } else if (windowWidth < 1000 && windowWidth > 500) {
            setEmbedHeight(500);
            setEmbedWidth(600);
        } else if (windowWidth < 500) {
            setEmbedHeight(300);
            setEmbedWidth(350);
        }
      };
 
    const handleResize = () => {
        checkWindowSize();
    };
   
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        checkWindowSize();


        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, [window.innerWidth]);


    return (
        <div>
            <iframe
                className="embedded-component"
                src={link}
                height={embedHeight}
                width={embedWidth}
            />
        </div>
    );
};


export default EmbeddedPDF;